import React from 'react';
import {
  useMutation,
  useQuery,
  useQueryClient,
} from 'react-query';
import { notification, Space, Typography } from 'antd';
import { useAxios } from './useAxios';

const { Text } = Typography;

export const fetchData = (path, onSuccess, params = undefined, enabled = true) => {
  const axiosInstance = useAxios();

  const result = useQuery(
    [path, params],
    () => {
      return axiosInstance.request({
        url: path,
        params,
        method: 'GET',
      });
    },
    {
      enabled: enabled,
      retry: false,
      refetchInterval: false,
      refetchOnWindowFocus: false,
      onSuccess: response => onSuccess(response.data),
      onError: (error) => {
        notification.error(getErrorDescription(error.response.data));
      },
    },
  );
  return result;
};

export const saveData = (path, method) => {
  const axiosInstance = useAxios();
  const queryClient = useQueryClient();

  const mutation = useMutation(({ dataToSend, id }) => {
      let entirePath = path;
      if (method === "PUT")
        entirePath = path + "/" + id;
      return axiosInstance.request({
        url: entirePath,
        data: dataToSend,
        method: method,
      });
    },
    {
      onError: (error, variables, context) => {
        notification.error(getErrorDescription(error.response.data));
      },
      onSuccess: (data, variables, context) => {
        notification.success({
          message: 'Success',
          description: 'Data saved successfully',
        });
        return queryClient.invalidateQueries(path);
      },
    },
  );
  return mutation;
};

export const deleteData = path => {
  const axiosInstance = useAxios();
  const queryClient = useQueryClient();

  const mutation = useMutation(
    params => {
      return axiosInstance.request({
        url: path,
        params,
        method: 'DELETE',
      });
    },
    {
      onError: (error, variables, context) => {
        notification.error(getErrorDescription(error.response.data));
      },
      onSuccess: (data, variables, context) => {
        notification.success({
          message: 'Success',
          description: 'Data deleted successfully',
        });
        return queryClient.invalidateQueries(path);
      },
    },
  );
  return mutation;
};

const getErrorDescription = (errorDetails) => {

  const description = (
    <div>
      <div style={{ marginTop: '2em', marginBottom: '1em' }}>
        {errorDetails.debugMessage}
      </div>
      <Space direction="horizontal" style={{ width: '100%' }} wrap>
        <Text type="secondary" style={{ fontSize: '0.7em' }}>
          {errorDetails.status}
        </Text>

        <Text type="secondary" style={{ fontSize: '0.7em' }}>
          ({errorDetails.timestamp})
        </Text>
      </Space>
      <Text type="secondary" style={{ fontSize: '0.7em' }}>
        Log ID: {errorDetails.logIdentifier}
      </Text>
    </div>
  );

  let header;
  if (errorDetails && errorDetails.message) {
    const result = errorDetails.message.replace(/([A-Z])/g, ' $1');
    header = result.replace('Exception', 'Error');
  }
  header = (<Text type="danger">{header || "Error"}</Text>)
  return {
    message: header,
    description: errorDetails ? description : '',
    duration: 10,
  };
};
